import axios from 'axios'
import Vue from 'vue'
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded'; 
let baseURL;
const http = {}
const LOGIN_PATH = '/authentication-server/business/loginByPhoneCode'
const TOKEN_KEY = 'token'
const LOGIN_PARAMS = {
    phone: '19700000000',
    code: '1024',
    smsPhone: '19700000000',
    withoutCode: 0
}
let refreshTokenPromise = null

if ( process.env.NODE_ENV !== 'production' ) {
    // baseURL = 'http://172.27.3.204/server-route/' //开发
    // baseURL = 'http://dev.qingting1.com:8080/server-route/'  //开发
    // baseURL = 'http://dev.qingting1.com/temp/server-route/'  //临时
    baseURL = 'http://cm.qingting1.com/server-route/'   //生产
}else { 
    baseURL = 'http://cm.qingting1.com/server-route/'
} 
axios.defaults.baseURL = baseURL
const isLoginRequest = (config = {}) => {
    return !!(config.url && config.url.indexOf(LOGIN_PATH) > -1)
}
const getStoredToken = () => localStorage.getItem(TOKEN_KEY) || ''
const saveToken = (token = '') => {
    if(token){
        localStorage.setItem(TOKEN_KEY, token)
    }
}
const requestNewToken = () => {
    if(refreshTokenPromise){
        return refreshTokenPromise
    }
    refreshTokenPromise = axios.post(LOGIN_PATH, LOGIN_PARAMS).then(res => {
        const token = res && res.data && res.data.data ? res.data.data.token : ''
        if(token){
            saveToken(token)
            return token
        }
        return ''
    }).catch(() => {
        return ''
    }).finally(() => {
        refreshTokenPromise = null
    })
    return refreshTokenPromise
}
const ensureToken = (forceRefresh = false) => {
    const token = getStoredToken()
    if(token && !forceRefresh){
        return Promise.resolve(token)
    }
    return requestNewToken()
}
http.get = (url,params={})=>{
    return new Promise((resolve, reject)=>{
    axios.get(url, {params: params}).then(res=>{
        resolve(res.data)
    }).catch(err=>{
        reject(err)
    })
    })
}
http.post = (url, params = {})=>{
    return new Promise((resolve, reject)=>{
    axios.post(url, params, {
        headers: {
        // 'Content-type': 'application/x-www-form-urlencoded'
        }
    }).then(res=>{
        resolve(res.data)
    }).catch(err=>{
        reject(err)
    })
    })
} 
http.postFormData = (url, params = {})=>{
    return new Promise((resolve, reject)=>{
      axios.post(url, params, {
        transformRequest: [
          function(oldData){
            let newStr = ''
            for (let item in oldData){
              newStr += encodeURIComponent(item) + '=' + encodeURIComponent(oldData[item]) + '&'
            }
            newStr = newStr.slice(0, -1)
            return newStr
          }
        ],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(res=>{
        resolve(res.data)
      }).catch(err=>{
        reject(err)
      })
    })
}  
axios.interceptors.request.use(async function (config) { 
    config.headers = config.headers || {}
    if(config && config.params){
      config.params.timestamp = new Date().getTime();
    }
    if(config && config.data && config.method !== 'put' && config.headers['Content-type'] !=="application/x-www-form-urlencoded"){
      config.data.timestamp = new Date().getTime();
    }
    if(!isLoginRequest(config)){
      const token = await ensureToken(false)
      config.headers['Authentication']=token || ""
    }else{
      config.headers['Authentication']=getStoredToken()
    }
    return config;
  })
axios.interceptors.response.use(
    async response => { 
        const { config, status, data } = response
        if(isLoginRequest(config)){
            return response
        }
        const code = data && data.code
        const message = (data && data.message) || ''
        const needRefreshToken = status === 401 || code === 401 || code === '401' || (
            typeof message === 'string' &&
            message.indexOf('token') > -1 &&
            (message.indexOf('失效') > -1 || message.indexOf('过期') > -1 || message.indexOf('无效') > -1)
        )
        if(needRefreshToken && config && !config._retryAuth){
            config._retryAuth = true
            const token = await ensureToken(true)
            if(token){
                config.headers = config.headers || {}
                config.headers['Authentication'] = token
                return axios(config)
            }
        }
        return response 
    }, error => {
        const response = error && error.response
        const config = error && error.config
        if(response && response.status === 401 && config && !isLoginRequest(config) && !config._retryAuth){
            config._retryAuth = true
            return ensureToken(true).then(token => {
                if(token){
                    config.headers = config.headers || {}
                    config.headers['Authentication'] = token
                    return axios(config)
                }
                return Promise.reject(error)
            })
        }
        return Promise.reject(error);
    }
)
export default http


// WEBPACK FOOTER //
// ./src/api/http.js